module.exports = __webpack_public_path__ + "static/media/everyday_digital_june23.a3d84859.webp";